import { Page } from "features/appstate/AppStateSlice";
import i18n from "i18n";

export const SSO_BASE = process.env.REACT_APP_SSO_BASE;
export const SMS_API_BASE = process.env.REACT_APP_SMS_API_BASE;
export const LANDING_PAGE_BASE = process.env.REACT_APP_LANDING_PAGE_BASE;
export const SURVEY_PAGE_BASE = process.env.REACT_APP_SURVEY_BASE;
export const UI_BASE = process.env.REACT_APP_UI_BASE;
export const BILLING_BASE = process.env.REACT_APP_BILLING_BASE;
export const URL_SERVICE_BASE = process.env.REACT_APP_URL_SERVICE_BASE;
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const SEO_UI_BASE = process.env.REACT_APP_SEO_UI_BASE;
export const KIKICOMI_BASE = process.env.REACT_APP_KIKICOMI_BASE;
export const NEXT_ENGINE_LINK_URL = process.env.REACT_APP_NEXT_ENGINE_LINK_URL;
export const NEXT_ENGINE_CLIENT_ID =
  process.env.REACT_APP_NEXT_ENGINE_CLIENT_ID;
export const NEXT_ENGINE_REDIRECT_URL =
  process.env.REACT_APP_NEXT_ENGINE_REDIRECT_URL;
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
export const PORTAL_BASE = process.env.REACT_APP_PORTAL_BASE;

export const MODE_SURVEY = "survey";

// This for padding around the main content card
const cardPaddingXl = 4;
const cardPaddingLg = 0;
const cardPaddingMd = 0;
export const getCardLayout = (page: Page) => {
  if (page === Page.statistics) {
    return {
      xs: { span: 24 },
      md: { span: 22, offset: 1 },
    };
  }
  return {
    xs: { span: 24 },
    md: { span: 24 - cardPaddingMd * 2, offset: cardPaddingMd },
    lg: { span: 24 - cardPaddingLg * 2, offset: cardPaddingLg },
    xl: { span: 24 - cardPaddingXl * 2, offset: cardPaddingXl },
  };
};

export const formItemLayout = {
  labelCol: {
    xs: 24,
    sm: 6,
  },
  wrapperCol: {
    xs: 24,
    sm: 14,
  },
};

export const mobileMediaQuery = "(max-width: 576px)";

export const defaultMessage = "\n\n配信停止：${optout}";

export const BOM = "\ufeff";

export const defaultRadioItemsValue = [
  { name: "radiogroup1", value: "選択肢１" },
  { name: "radiogroup2", value: "選択肢２" },
  { name: "radiogroup3", value: "選択肢３" },
];
export const defaultPromptRadioItemsValue = [
  { name: "radiogroup1", value: "特になし", notPrompt: true },
  { name: "radiogroup2", value: "感想を書く" },
];
export const defaultGenerationItems = [
  {
    name: "radiogroup1",
    value: i18n.t("survey.questionText.teenagers"),
  },
  {
    name: "radiogroup2",
    value: i18n.t("survey.questionText.twenties"),
  },
  {
    name: "radiogroup3",
    value: i18n.t("survey.questionText.thirties"),
  },
  {
    name: "radiogroup4",
    value: i18n.t("survey.questionText.forties"),
  },
  {
    name: "radiogroup5",
    value: i18n.t("survey.questionText.fifties"),
  },
  {
    name: "radiogroup6",
    value: i18n.t("survey.questionText.seniors"),
  },
  {
    name: "radiogroup7",
    value: i18n.t("survey.questionText.noAnswer"),
  },
];

export const defaultCheckboxItemsValue = [
  { name: "checkbox1", value: "選択肢１" },
  { name: "checkbox2", value: "選択肢２" },
  { name: "checkbox3", value: "選択肢３" },
];

export const surveyTypeStore = "store";
export const surveyTypeEc = "ec";
export const proofReadingModel = ["キキコミ", "生成エラー時再生成テスト"];

export const PAGE_LIMIT = 100;

export const timeFormat = "HH:mm:ss";

export const optoutPageTemplateTagItems = {
  [i18n.t("mailTemplate.tags.storeName")]: "${storeName}",
  [i18n.t("mailTemplate.tags.storeLogo")]: "${storeLogo}",
};

export const mailTemplateTagItems = {
  [i18n.t("mailTemplate.tags.reviewLink")]: "${reviewLink}",
  [i18n.t("mailTemplate.tags.optoutLink")]: "${optoutLink}",
  ...optoutPageTemplateTagItems,
};

export const promotionMailTemplateTagItems = {
  [i18n.t("promotionMailTemplate.tags.optoutLink")]: "${optoutLink}",
  [i18n.t("promotionMailTemplate.tags.storeName")]: "${storeName}",
  [i18n.t("promotionMailTemplate.tags.omikujiUrl")]: "${omikujiUrl}",
  [i18n.t(
    "promotionMailTemplate.tags.omikujiUrlStoreName"
  )]: "${omikujiUrlStoreName}",
  [i18n.t("promotionMailTemplate.tags.fortuneUrl")]: "${fortuneUrl}",
  [i18n.t(
    "promotionMailTemplate.tags.fortuneUrlStoreName"
  )]: "${fortuneUrlStoreName}",
};

export enum ImpressionPromptMode {
  Random = "random",
  Always = "always",
}

export const ecAllowAll = "off";
export const ecSameProductExclude = "same_product";
export const ecOptoutTypeStore = "store";
export const mailExclusionAddMode = "MAIL_EXCLUSION_ADD_MODE";
export const mailExclusionUpdateMode = "MAIL_EXCLUSION_UPDATE_MODE";
export const buttonDiscriminator = "BUTTON";
export const textDiscriminator = "TEXT";

export enum LanguageSettingsCode {
  en = "en",
  ja = "ja",
}

export const clientSettingLanguage = "CLIENT_SETTING_LANGUAGE";

interface StringKeyInterface {
  [key: string]: string;
}

export const isEnabledAllowedItems: StringKeyInterface = {
  DIRECT_POST_BUTTON_LABEL: "DIRECT_POST_BUTTON_LABEL_IS_ENABLED",
  DIRECT_POST_LINK_BUTTON_LABEL: "DIRECT_POST_LINK_BUTTON_LABEL_IS_ENABLED",
};

export const defaultClientSettingsValues: StringKeyInterface = {
  START_SURVEY_BUTTON_LABEL: "アンケートに答える",
  SURVEY_TEXT_BUTTON_LABEL: "クチコミ文章案を見る",
  DIRECT_POST_BUTTON_LABEL: "直接クチコミする",
  REDIRECT_COPY_POST_PAGE_BUTTON_LABEL: "コピーしてクチコミ投稿画面を開く",
  DIRECT_POST_LINK_BUTTON_LABEL: "文章案を使わず、自分で書いて投稿する",
  REDIRECT_POST_PAGE_BUTTON_LABEL: "クチコミ投稿画面を開く",
  UPPER_TEXT_GENERATION_IN_PROGRESS_LABEL:
    '<div class="loader-supertext"><span>アンケートへの回答内容から</span><br><span>クチコミ文章案を作成中です。</span></div>',
  LOWER_TEXT_GENERATION_IN_PROGRESS_LABEL:
    '<p>クチコミ投稿文を書くお手伝いをするための文章案です。<span class="caution-text">文章案が作成されたら必ず内容をご確認頂き、気持ち・感想・体験に合わせて書き直して投稿にご利用ください。</span></p>',
  UPPER_GENERATED_TEXT_RESULT_LABEL: "クチコミ文章案",
  LOWER_GENERATED_TEXT_RESULT_LABEL:
    '<p style="margin-bottom: 0px;">上記はご回答いただいた内容をもとに生成した文章案です。<span class="caution-text">必ず内容をご確認頂き、ご自身の気持ち・感想・体験に合わせて“直接編集”してから、クチコミにご活用ください。</span></p>',
  REDIRECT_POST_PAGE_LABEL:
    '<div class="overlay-title-text">文章をコピーしました</div><div class="overlay-subtle-text">クチコミページで【貼り付け】</div><div class="overlay-subtle-text">してお使いください。</div>',
};

export const defaultEnglishClientSettingsValues: StringKeyInterface = {
  START_SURVEY_BUTTON_LABEL: "Answer the Survey",
  SURVEY_TEXT_BUTTON_LABEL: "View Review Draft",
  DIRECT_POST_BUTTON_LABEL: "Post Review Directly",
  REDIRECT_COPY_POST_PAGE_BUTTON_LABEL:
    "Copy this content and open the review page",
  DIRECT_POST_LINK_BUTTON_LABEL: "Use your own words to write and post",
  REDIRECT_POST_PAGE_BUTTON_LABEL: "Open review page",
  UPPER_TEXT_GENERATION_IN_PROGRESS_LABEL:
    '<div class="loader-supertext"><span>Generating a review draft</span><br><span>based on your survey responses.</span></div>',
  LOWER_TEXT_GENERATION_IN_PROGRESS_LABEL:
    '<p>The review draft is created to help you write your review. <span class="caution-text">Please make sure to review the content once it is generated and adjust it to match your feelings, impressions, and experiences before posting.</span></p>',
  UPPER_GENERATED_TEXT_RESULT_LABEL: "Review Draft",
  LOWER_GENERATED_TEXT_RESULT_LABEL:
    '<p style="margin-bottom: 0px;">The above draft is based on your responses. <span class="caution-text">Please be sure to review the content, adjust it to match your feelings, impressions, and experiences, and then use it for your review.</span></p>',
  REDIRECT_POST_PAGE_LABEL:
    '<div class="overlay-title-text">The text has been copied.</div><div class="overlay-subtle-text">Please paste it</div><div class="overlay-subtle-text">on the review page.</div>',
};

export const clientSettingLabelTextType = ["UPPER_GENERATED_TEXT_RESULT_LABEL"];

export const SSO_CLIENT_ID = "review";

export const UI_VERSION_OPTIONS = [
  { label: "V1", value: "v1" },
  { label: "V2", value: "v2" },
];

export const UI_V2_ANSWER_TIME_OPTIONS = [
  { label: "1分", value: 1 },
  { label: "2分", value: 2 },
  { label: "3分", value: 3 },
  { label: "4分", value: 4 },
  { label: "5分", value: 5 },
  { label: "6分", value: 6 },
  { label: "7分", value: 7 },
  { label: "8分", value: 8 },
  { label: "9分", value: 9 },
  { label: "10分", value: 10 },
  { label: "11分", value: 11 },
  { label: "12分", value: 12 },
  { label: "13分", value: 13 },
  { label: "14分", value: 14 },
  { label: "15分", value: 15 },
  { label: "16分", value: 16 },
  { label: "17分", value: 17 },
  { label: "18分", value: 18 },
  { label: "19分", value: 19 },
  { label: "20分", value: 20 },
];
